import { useState, useEffect } from "react";
import { getUserPreferredCurrency } from "@/utils/currencyMapping";

export function useUserCurrency() {
  const [currency, setCurrency] = useState<string>("USD");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const loadCurrency = async () => {
      try {
        setIsLoading(true);
        const userCurrency = await getUserPreferredCurrency();
        setCurrency(userCurrency);
      } catch (err) {
        setError(err instanceof Error ? err : new Error(String(err)));
        console.error("Error loading user currency:", err);
      } finally {
        setIsLoading(false);
      }
    };

    loadCurrency();
  }, []);

  const setUserCurrency = (newCurrency: string) => {
    try {
      localStorage.setItem('user_preferred_currency', newCurrency);
    } catch (error) {
      console.error('Error saving to localStorage:', error);
      localStorage.clear();
    }
    setCurrency(newCurrency);
  };

  return { 
    currency, 
    isLoading, 
    error, 
    setUserCurrency 
  };
}
